export const WARMUP_BARS = 200;
export const PLAY_BARS = 200;
export const TOTAL_WINDOW = WARMUP_BARS + PLAY_BARS;

export const STARTING_EQUITY = 10_000;

export const MIN_RISK_PCT = 0.1;
export const MAX_RISK_PCT = 10;

export const Y_FLIP_PROBABILITY = 0.5;

export const SCRATCH_R_THRESHOLD = 0.1;

export const MANIFEST_URL = '/data/manifest.json';
export const BARS_URL_PREFIX = '/data/';

export const DB_NAME = 'investment-teach';
export const DB_VERSION = 1;
export const SCHEMA_VERSION = 1;
export const ACCOUNT_KEY = 'default';
